import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandBackground from "@/components/BrandBackground";

// Lazy-load below-the-fold components to reduce initial JS bundle
const Benefits = lazy(() => import("@/components/Benefits"));
const FeaturedProjects = lazy(() => import("@/components/FeaturedProjects"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const SocialProof = lazy(() => import("@/components/SocialProof"));
const FAQ = lazy(() => import("@/components/FAQ"));
const Newsletter = lazy(() => import("@/components/Newsletter"));
const ContactCTA = lazy(() => import("@/components/ContactCTA"));
const NewsletterPopup = lazy(() => import("@/components/NewsletterPopup"));

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen relative">
      <BrandBackground />
      <Header />
      <Hero />
      <Suspense fallback={null}>
        <Benefits />
        <FeaturedProjects />
        <HowItWorks />
        <SocialProof />
        <FAQ />
        <Newsletter />
        <ContactCTA />
        <NewsletterPopup />
      </Suspense>
    </div>
  );
};

export default Index;
